import { timeHelper } from 'src/app/helpers';
import { getEnumKeyByValue } from 'src/app/helpers/enum.helper';
import { LogEntities, UserAction } from 'src/enums/logger-enum';
import { Log } from 'src/types/log.type';
import { UserEventsColumnType } from 'src/types/table.type';

export const getDetailsMessage = (log: UserEventsColumnType) => {
  switch (log.action) {
    case 'Create':
      return `${getEnumKeyByValue(LogEntities, log.entity)} "${log.entityName}" is created.`;
    case 'Update':
      return `${getEnumKeyByValue(LogEntities, log.entity)} "${log.entityName}" is updated.`;
    case 'Delete':
      return `${getEnumKeyByValue(LogEntities, log.entity)} "${log.entityName}" is deleted.`;
    case 'Upload':
      return `File uploaded`;
    case 'NSearch':
      return `Block data is searched`;
    default:
      return '';
  }
};

export const convertUserEventsToTableData = (logs: Log[]) => {
  const tableData: UserEventsColumnType[] = [];
  logs.forEach((log: any) => {
    tableData.push({
      id: log.id,
      action: getEnumKeyByValue(UserAction, log.action),
      actor: log.actor,
      timestamp: timeHelper.formatDate(log.createdAt),
      details: log.details,
      entityName: log.entityName,
      entity: log.entity,
    });
  });
  return tableData;
};
